import HamHeader from '../Header/HamburgerHeader';
import constant from '@components/common/globalization';
import ErrorTable from './tabledata';
import { useOutletContext } from 'react-router-dom';
import { FLABEL } from '@containers/Fireboard/fireboardVariables';


const ErrorOrders = props => {
  const { setPopup } = props;
  const { tableData } = useOutletContext();

  const errorOrdersList = Object.values(tableData).filter(
    check => check?.orders?.[0]?.orderStatusId === 9
  );

  return (
    <div className="w-100 h-100 position-relative text-white p-3">
      <HamHeader
        label={FLABEL().HEADER_ERROR_ORDERS}
        onClickback={() => setPopup(null)}
      />

      <div className="h-100">
        <ErrorTable errorOrdersList={errorOrdersList} />
      </div>
    </div>
  );
};

export default ErrorOrders;
